import React from "react";
import CommentSection from "../../Ordering/common/CommentSection";

const Comments = props => {
    return <div className="tabContent">
        <CommentSection {...props} />
    </div>;
};

export default Comments;
